import _ from 'lodash'

const userRegex = /(@@?)([^\s]+)/g
const metadataRegex = /([+#])([^\s]+)/g

export default {
    parse: (context, content, workarea = null, maxRecv, allowZero = false) => {
        // Set wid to workarea (assume string)
        let wid = workarea

        // Check if workarea is object if that then use .id as wid
        if (typeof workarea === 'object' && workarea !== null) {
            wid = workarea.id
        }

        var task = {
            content: content,
            workarea: wid,
            users: [],
            tags: [],
            categories: [],
            user_limit: null
        }

        if (maxRecv !== null && maxRecv !== undefined && (maxRecv > 0 || (maxRecv === '0' && allowZero))) {
            task.user_limit = maxRecv
        }

        var metadata = content.match(metadataRegex)
        if (metadata) {
            _.each(metadata, meta => {
                var name = meta.substring(1)
                switch (meta[0]) {
                case '#':
                    task.tags = _.union(task.tags, [name])
                    break
                case '+':
                    task.categories = _.union(task.categories, [name])
                    break
                }
            })
        }

        var users = content.match(userRegex)
        if (users) {
            _.each(users, user => {
                var name = user.substring(1)

                switch (name[0]) {
                case '@':
                {
                    var group = _.find(context.$store.state.group.groups, { name: name.substring(1) })

                    if (group) {
                        task.users = _.union(task.users, _.map(group.members, item => ({ username: item.username })))
                    }

                    break
                }
                default:
                {
                    var friend = _.find(context.$store.state.friend.friends, { username: name })

                    if (friend) {
                        task.users = _.union(task.users, [friend])
                    }

                    break
                }
                }
            })
        }

        return task
    }
}



// WEBPACK FOOTER //
// ./src/utils/parser.js